var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"downlaod"},[_c('za-banner'),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"download-box"},[_c('h2',{staticClass:"titile"},[_vm._v("更简洁更流畅的体验")]),_c('div',{staticClass:"tips"},[_vm._v("立即下载，享受更多权益")]),_c('a',{attrs:{"href":"https://cdn.eaqiang.com/apk/com.excean.dualaid-16022-17-release.apk"}},[_c('div',{staticClass:"btn"},[_vm._v("立即下载")])])])
}]

export { render, staticRenderFns }